import { ICredentials } from './ICredentials'

export class DefaultCredentials implements ICredentials {
  constructor(readonly username: string, readonly password: string) {}
}
